import type { IStyleDTO } from '../ICompanySettings';
import type { EGender, IAvailabilityDTO } from '../IEmployee';

export type TGeneralWebsocketResponse = IGeneralWebsocketResponseMap[keyof IGeneralWebsocketResponseMap];
export enum EGeneralWebsocketResponseType {
    Style = 'style',
    EmployeeUpdate = 'employeeUpdate',
}

export interface IGeneralWebsocketResponseMap {
    [EGeneralWebsocketResponseType.Style]: {
        type: EGeneralWebsocketResponseType.Style;
        style: IStyleDTO;
    };
    [EGeneralWebsocketResponseType.EmployeeUpdate]: {
        type: EGeneralWebsocketResponseType.EmployeeUpdate;
        employee: {
            id: number;
            firstName: string;
            lastName: string;
            gender: EGender;
            phoneNumber?: string;
            title: string;
            email: string;
            availability?: IAvailabilityDTO;
            pictureId: string | null;
            description?: string;
        };
    };
}
